<script setup lang="ts">
const header = ref<HTMLElement | null>(null)
const headerHeight = ref('auto')

useResizeObserver(header, (entries) => {
  const entry = entries[0]

  if (entry?.contentRect) {
    const { height } = entry.contentRect
    headerHeight.value = `${height}px`
  }
})

provide('ui-heading-seo-level', 'div')
provide('ui-heading-wcag-level', '')
</script>

<template>
  <header
    ref="header"
    class="header"
  >
    <Html
      v-if="headerHeight !== 'auto'"
      :style="`--header-height: ${headerHeight};`"
    />

    <div class="header__container">
      <AppLogo
        data-testid="logo"
        class="header__logo"
      />

      <div class="header__entries header__entries--desktop">
        <SearchComponent class="header__search" />

        <div class="header__entries header__entries--mobile">
          <HeaderWishlist class="header__wishlist" />

          <HeaderCart class="header__cart" />
        </div>
      </div>

      <NavigationComponent class="header__navigation" />
    </div>
  </header>
</template>

<style>
@import url("~layers/components/Header/Component.css");
</style>
